module.exports = __webpack_public_path__ + "media/images/shared/about_live/talkport/6-cf09a21ea1a1d135cc35b5181655d5ec.png";